import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RecourseCampaignDetailsModel } from '../../content/recourse-campaign/model/recourse-campaign-details-model';
import { RecourseCampaignModel } from '../../content/recourse-campaign/model/recourse-campaign-model';
import { RecourseCampaignStateModel } from '../../content/recourse-campaign/model/recourse-campaign-state-model';
import { UserByRightModel } from '../../content/recourse-campaign/model/user-by-right-model';
import { completeEndpoint, EndpointPart } from '../../core/global';
import { EndpointService } from '../endpoint/endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class RecourseCampaignService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);

  public getRecourseCampaigns(): Observable<RecourseCampaignModel[]> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.GET_RECOURSE_CAMPAIGN));
    return this.http.get<RecourseCampaignModel[]>(url);
  }

  public getRecourseCampaignEx(campaignRecourseId: string): Observable<RecourseCampaignDetailsModel> {
    const urlParams: Map<string, string> = new Map();
    urlParams.set('campaignRecourseId', campaignRecourseId);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_RECOURSE_CAMPAIGN_DETAILS),
      urlParams,
    );
    return this.http.get<RecourseCampaignDetailsModel>(url);
  }

  public getRecourseCampaignExDetails(
    campaignRecourseId: string,
    campaignRecourseExId: string,
  ): Observable<RecourseCampaignDetailsModel> {
    const urlParams: Map<string, string> = new Map();
    urlParams.set('campaignRecourseId', campaignRecourseId);
    urlParams.set('campaignRecourseExId', campaignRecourseExId);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_RECOURSE_CAMPAIGN_EX_DETAILS),
      urlParams,
    );
    return this.http.get<RecourseCampaignDetailsModel>(url);
  }

  public getUserByRight(rightName: string): Observable<UserByRightModel> {
    const urlParams: Map<string, string> = new Map();
    urlParams.set('rightName', rightName);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_USER_BY_RIGTH_NAME),
      urlParams,
    );
    return this.http.get<UserByRightModel>(url);
  }

  public getRecourseCampaignStateList(): Observable<RecourseCampaignStateModel> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.GET_RECOURSE_CAMPAIGN_STATE));
    return this.http.get<RecourseCampaignStateModel>(url);
  }

  public updateRecourseCampaign(recourseCampaignDetailsModel: RecourseCampaignDetailsModel): Observable<any> {
    const pathVariables: Map<string, string> = new Map<string, string>();
    pathVariables.set('campaignRecourseId', recourseCampaignDetailsModel.campaignRecourseId);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.PUT_RECOURSE_CAMPAIGN_DETAILS),
      pathVariables,
    );
    return this.http.put<any>(url, recourseCampaignDetailsModel);
  }

  public getQppSysReserveUrl(): Observable<string> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.GET_URL_QPP_SYS_RESERVE));
    return this.http.get(url, { responseType: 'text' });
  }

  public duplicateRecourseCampaign(recourseCampaignDetailsModel: RecourseCampaignDetailsModel): Observable<any> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.POST_DUPLICATE_CAMPAIGN));
    return this.http.post<any>(url, recourseCampaignDetailsModel);
  }
}
